export default {
  profile:'Profile',
  logout:'Logout',
  dashboard:'Dashboard',
  password:'Password',
  language:'Language',
  paymentbr:'Payment',
  subscriptionPaymentMethod:'Subscription & Payment Method',
  nothingchanged:'Nothing Changed',
  somethingWentWrong:'Something went wrong ! Please try againg later',
  pleaseTryAgainAfterSometime:'Please try againg after sometime',
  noChanges:'Not Changed',
  invalidEmailFormat:'The email format is invalid',
  chooseYourPreferredLanguage:"Please choose your preferred language.",
  selectLanguage:'Select Language',
  update:'Update',
  languagePreferences: 'Language Preferences',
  packageOf:'Package Of',
  satelliteReport:"satellite reports",
  pastureReport:"pasture reports",
  upTo:'Up To',
  animals:'animals',
  back:'Back',
  perMonth:"Per Month",
  perYear:"Per Year",
  continue:"Continue",
  changePlan:"Change Plan",
  addOn:"Add-on",
  totalPrice:"Total Price",
  availableAddOns:"Available Add-Ons",
  next:"Next",
  congratulations:"Congratulations",
  done:"DONE",
  deforestationComplianceAssessment:"Deforestation Compliance Assessments",
  warning:"Warning",
  yourDataMightLost:"Your data might be lost.",
  clickOnSaveBtnMsg:"Click on save button to preserve your data",
  discardChanges:"Discard Changes",
  action:"Actions",
  sendRequest:"Send Request",
  success:"Success",
  yourRequestSuccessfullySubmitted:"Your request was successfully submitted.",
  informShortly:"Your request has been submitted successfully. Your analysis report will be sent to you shortly.",
  search:'Search',
  pending:'Pending',
  approved:"Approved",
  rejected:'Rjected',
  primaryGeofence:"Primary Geofence",

  "Zero/Negligible Deforestation Probability":"Zero/Negligible Deforestation Probability",
  "Low Deforestation Probibility":"Low Deforestation Probibility",
  "High Deforestation Probibility":"High Deforestation Probibility",

  login: {
    welcome: "Welcome! Log In",
    welInfo: "Enter your credentials.",
    login: "Login",
    emailMobile:'Email/Mobile',
    forgotPassword:"Forgot Password",
    register:"Register",
    unableToLogin:"Unable to Login",
    emailMobileCannotEmpty:"Email/Mobile can not be empty.",
    invalidEmailMobileFormat:"Invalid email/mobile format.",
    passwordCannotEmpty:"Password can not be empty.",
    passwordLengthCanlessthan8:"Password length can not be less then 8 characters.",
    email:'Email',
    phone:'Phone',
    or:'OR',
    alreadyHaveAccount:'Already have an account',
    loginNow:'Login Now',
    registerOption:"Choose an option to sign up",
    signUpWith:"Sign Up with",
  },
  user:{
    profileUpdated:'Profile has successfully updated',
    profileNotUpdated:'Profile has not updated',
    otpSentOnEmail:'OTP was sent successfully !',
    otpSentSuccessFully:'Your OTP code was sent',
    unableToVerifyEmail:'Unable to verify the email',
    emailCanNotBeEmpty:'Email fields can not empty',
    firstName:'First Name',
    lastName:'Last Name',
    email: 'Email',
    mobile:'Mobile',
    currentPassword:'Current Password',
    newPassword:'New Password',
    repeatNewPassword:'Repeat New Password',
    firstNameRequired:'Firstname is required.',
    lastNameRequired:'Lastname is required',
    emailRequired:'Email is required',
    onlyAlphabet:'Can only contain alphabets',
    notMoreThan15Char:"Can't be more then 15 characters",
    phoneCannotLessThan8Char:"Phone can not be less then 8 chars",
    countryCodeRequire:'Country code is required',
    changePassword: "Change Password",
    goodIdeaToUsePassword:"It’s a good idea to use a strong password that you’ re not using elsewhere.",
    enterCurrentPassword:'Enter Current Password',
    enterNewPassword:"Enter New Password",
    reEnterPassword:"Re-Enter Password",
    pleaseTypeOldPassword: "Please type old password.",
    pleaseTypeNewPassword: "Please type new password.",
    pleaseTypeConfirmPassword: "Please type confirm password.",
    passwordChangedSuccesFully: "Password changed successfully",
    passwordDoesNotMatch: "Passwords does not match.",
    passwordRequired:'Password is required',
    emailOrPhoneIsRequired:"Email or Phone Number is required"
  },
  subscription:{
    subscription:'Subscription',
    membershipPlan:"Membership Plans",
    currentMembershipPlan:"Current membership plan",
    validUpTo:"Valid Up to",
    viewAllAddOns:"VIEW ALL ADD-ONS",
    renewValidity:"Renew Validity",
    buyNow:"Buy Now",
    upgradeMembershipPlan:'Upgrade membership plan',
    chooseYourMembershipPlan:"Your Chosen Membership Plan",
    chooseOptionalAddOns:"Your can choose optional Add-ons",
    yourSelectedAddons:"Your Selected Add-Ons",
    addAnotherAddOn:"Add Another Add-On",
    paymentMethod:"Payment Method",
    addingAPaymentMethod:"Adding A Payment Method",
    paymentSuccessful:"Your Payment was  Successful!",
    weHaveEmailed:"We have emailed a copy of your recipt to example@email.com",
    paymentAuthorizedSuccessfully:"Payment authorized successfully.",
    paymentSuccessfulPrompt:"Payment successful. Plan upgraded.",
    paymentCancelled:'Payment cancelled. Please try again.'
  },
  registerFarm:"Register Farm",
  requestDeforestationReport:"Request Deforestation Report",
  paymentMenu:"Payment",
  complianceCertificate:"Compliance Certificate",
  helpDisk:'Help Disk',
  faqs:"FAQ's",
  enquiries:"Enquiries",
  contactUs:"Contact Us",
  payment:{
    basicPlan:"Basic Plan",
    advancePlan:'Advance Plan',
    usdPerMonthPlus:'USD per month plus',
    perReport:"per report",
    deforestationAnalyticsCertificateDownload:"Deforestation analytics certificate download"
  },
  farm: {
    selectFarm:"Select Farm",

    farmOwnershipType:'Farm Ownership Type',
    licenceNum:'Licence Number',
    viewFarm: "View Farm",
    stateProvince:"Province/State",
    postalNumberShouldSimilarToFarm:"The postal Number of farm similar to House number.",
    videoTutorial:"Video Tutorial",
    clickOnMapMSG:"Click on the map to start geofencing",
    prev:"Prev",
    next:"Next",
    dragVertexMsg:"You can also drag the vertex, or delete them using the delete button on the right side. Geofence can also be cleared using the clear button",
    farmAddedSuccessfully:"Farm added successfully",
    perimeter:"Perimeter",
    area:"Area",
    clearGeofence:"Clear Geofence",
    deleteSelectedVertex:"Delete Selected Vertex",
    pleaseStartDrawing:"Please start drawing geofence on map.",
    chooseTheDate:"Choose the date",
    updateGeofenceForThisFarm:"UPDATE GEOFENCE for this farm",
    farmUpdateSuccessfully:"Farm updated successfully",
    farmZone:"Farm Zones",
    addNewZones:"Add New Zones",
    zoneName:"Zone Name",
    addZoneToCreate:"Please click on Add Zones to create a Zone for this farm.",
    noZoneCreated:"No Zones have been created yet.",
    searchAndAddPin:"Search and add a pin",
    zoneNameWillBeHere:"Zone Name will be here",
    editZone:"Edit Zone",
    nameOfTheField:"Name Of The Field",
    zoneDetails:"Zone Details",
    addZone:"Add Zone",
    nameOfTheZone:"Name Of the zone",
    geofenceIsRequiredToAdd:"Geofence is required to add zone. Click `Edit Farm` to add Geofence details to your farm.",
    thisFieldApplyHelpText:"This field only applies to you if you belong to any cooperative ( A cooperative is an autonomous association of persons united voluntarily to meet their common economic, social and cultural needs and aspirations through a jointly-owned and democratically-controlled enterprise). IF you belong to a cooperative, please indicate the unique identifier of that cooperative, it can be a registrration or license number uniquely identifying the cooperative  you associate with.",
    // licenseExpiryDate:"License Expiry Date",
    farmRegistrationID:"Farm Registration ID",
    farmerName:"Farmer Name",
    farmerRegistrationID:"Farmer Registration ID",
    dateOfRequest:"Date of Request",
    status:"Status",

    address:'Address',
    save:'Save',
    farmAddress: "Farm Location Address",
    corporateName:'Corporate Name',
    corporateMailingAddress:'Corporate Mailing Address',
    farmID: "Farm ID",
    onTheFarm: "On the Farm",
    userRoles: "User Roles",
    adduser: "Add User",
    addAuser: "Add a User",
    uploadUsers: "Upload Users",
    addNewUser: "Add New User",
    selectDept: "Select Department",
    selectRole: "Select Role",
    editUser: "Edit User",
    totalFarms: "Total Farms",
    NoAnimalsRegisteredForthisFarm: "No Animals are Registered for this Farm",
    farmsPerPage: "Farms per page",
    regularFarms: "Regular Farms",
    farmRegisteredProducts: "Farm Registered Products",
    searchByFarmNameAndId: "Search by Farm Name and Id",
    loadingProductsPleaseWait: "Loading Products... Please wait",
    farmName: "Farm Name",
    farmLocation: "Farm Location",
    
    productName: "Product Name",
    stockStatus: "Stock Status",
    inStock: "In Stock",
    searchByProductName: "Search By Product Name",
    productCategory: "Product Category",
    products: "Products",
    yourLocationIsDisabled:"Your location is disabled. Please search your location from left menus.",
    close:"Close",
    farms: "Farms",
    zones: "Zones",
    registerAfarm: "Register A Farm",
    govtRegistry: "Govt. Registry",
    cooperativeID: "Cooperative/Union ID",
    cooperativeName: "Cooperative/Union Name",
    farmType: "Farm Type",
    contractMating: "Contract Mating",
    customization: "Customization",
    recordsPerpage: "Records per Page",
    restoreDefault: "Restore Default",
    apply: "Apply",
    CommunityName: 'Community Name',
    searchState:"Search by Farm ID, Gov. Registry, Cooperative ID, Farm Type, Contract Mating",
    farmOwner: "Farm Owner",
    govRegistrationNo: "Govt Registration Number",
    farmInformation: "Farm Information",
    ownershipType: "Ownership Type",
    farmLicenseInformation: "Farm License Information",
    licenseNumber: "License Number",
    licenseExpiryDate: "License Expiry Date",
    regulatorName: "Regulator Name",
    regulatorRepresentativeName: "Regulator Representative Name",
    farmLocationSize: "Farm Location & Size",
    productionSystem: "Farming System",
    country: "Country",
    state: "State",
    city: "Village/Town/City",
    farmNumber: "Farm Number",
    postal: "Postal/Zip Code",
    houseNumber: "House Number",
    farmRegistration: "Farm Registration",
    cancel: "Cancel",
    register: "Register",
    ok: "ok",
    totalFarmSize: "Total Farm Size",
    geographicLocation:"Geographic Location",
    farmGeographicLocation: "Farm Geographic Location",
    perimeterPointLongitude: "Perimeter Point Longitude",
    perimeterPointLatitude: "Perimeter Point Latitude",
    perimeterPointLabel: "Perimeter Point Label",
    perimeterLength: "Perimeter Length",
    farmLatitude: "Farm Latitude",
    farmLongitude: "Farm Longitude",
    latitude:"Latitude",
    longitude:"Longitude",
    areaUnit:"Area Unit",
    walkAndMeasure:"WALK AND MEASURE",
    useGeofenceTool:"USE GEOFENCE TOOL",
    editFarm: "Edit Farm",
    update: "Update",
    editAfarm: "Edit a farm",
    nextFarm: "Next Farm",
    nameoftheFarm: "Name of the Farm",
    registerAProduct: " Register A Product",
    farmProducts: "Farm Products",
    calf: "Calf",
    steer: "Steer",
    heifer: "Heifer",
    sire: "Sire",
    dam: "Dam",
    registerAnAnimal: "Register An Animal",
    farmAnimals: "Farm Animals",
    farm_type: "Farm-type",
    farm_Owner: "Farm-Owner",
    dateOfRegistration: "Date Of Registration",
    dataIsNotAvailableForThisFarm: "Data Is Not available for this Farm",
    registerNewProduct: "Register A New Product",
    information: "Information",
    licenseInfo: "License Info",
    locationInfo: "Location Info",
    geoLocation: "Geo Location",
    perimeterLengthState: "Length of Farms Perimeter (fence length)",
    totalFarmSizeState: "Size of a Farm",
    productionSystemState: "Production System used in the Farm",
    contractMatingState:"Code of Contract Mating Programme in which the Farm Participate.",
    ownershipTypeState: "Type of Ownership",
    regulatorRepresentativeNameState:"Name of the person representing regulator who released the license",
    regulatorNameState: "Name of regulator which released the license",
    licenseExpiryDateState: "Date when the current License is Expired",
    licenseNumberState: "License Number released by Regulator",
    plotNumberState: "House number of the farm.",
    plotNumber: "Farm Number",
    streetStatement: "Street name of the farm.",
    cityStatement: "City where the farm is located in.",
    stateStatement: "Region of the country where the farm is located in.",
    countryState: "Country where the farm is located in.",
    farmStateInfo: "Farm location address",
    perimeterPointLongitudeState: "Longitude of one point on farm.",
    perimeterPointLatitudeState: "Latitude of one point on farm.",
    perimeterPointLabelState: "Label of Point.",
    farmLongitudeState: "Longitude of the farm.",
    farmLatitudeState: "Latitude of the farm.",
    deleteFarm: "Delete Farm",
    corporateRegistrationNum:"Corporate Registration Number",
    farmLocationIsRequired:"Farm Location is required."
  },
  deforestation:{
    addZoneToThisFarm:"Add Zones to this farm",
    
    copy:'Copy',
    shareQRCode:'Share Qr Code',
    registerFarm:"Registered Farm",
    nonRegisterFarm:"Non-Registered Farm",
    chooseRegistrationType:"Choose Registration Type",
    doYouwantToregisterSingleFarm:"Do you want to register a single animal or a group of animals?",


    eudrForestAssessment:"EUDR Forest Assessments",
    requestEudrForestAssessment:"REQUEST EUDR FOREST ASSESSMENT",
    pleaseChooseOption:"Please Choose Option",
    requestForestReport:"Request Forest Report",
    noDeforestationReportMsg:"No deforestation reports have been requested. Kindly request some deforestation reports to get them listed here.",
    allCountries:'All Countries',
    allRegions:'All Regions',
    allFarms: 'All Farms',
    allStatus: 'All Status',
    viewCertificate:'View Certificate',
    requestComplianceCertificate:"REQUEST COMPLIANCE CERTIFICATE",
    assessmentNo:"Assessment No",
    blockchainCertificationInfo:"Blockchain Certificate Validation Hash Will Be Available Upon Acceptance of Certificate",
    blockchainCertificationValidation:"Blockchain Certificate Validation",
    openBlockchainPage:"Open Blockchain Page",
    clickOnAboveLink:"Click on above link to validate certificate on blockchain",
    shareCertificate:"Share Certificate",
    high:"High",
    low:"Low",
    zeroOrNegigible:"Zero or Negigible",
    deforestationProbability:"Deforestation Probability",
    colorCode:"Color Code",
    geofenceAarea:"Geofence Area",
    percentageOfGeofenceArea:"Percentage of Geofence Area",
    overallDeforestationProbability:"Overall Deforestation Probability",
    deforestationComplianceReport:'Deforestation Compliance Reports',
    noDeforestationComplianceReport:'No Deforestation Complianc eReport Found',
    loadingDeforestationComplianceReport:'Loading Deforestation Complianc eReport',
    farmRegistrationId:'Farm Registration ID',
    farmerName:'Farmer Name',
    farmerRegistrationId:'Farmer Registration ID',
    uniqueFarmerId:"Unique Farmer ID",
    uniqueFarmId:"Unique Farm ID",
    farmLocation:'Farm Location',
    area:'Area',
    farmAddress:'Farm Address',
    dateOfRequest:'Date of Request',
    status:'Status',
    settings:'Settings',

    assignmentIssued:'Assignment Issued',
    certificateIssued:'Certificate Issued',

    complianceCertification:'Compliance Certification',
    noComplianceCertification:'No Compliance Certification Found',
    loadingComplianceCertification:'Loading Compliance Certification',

    assessmentReport:'Assessment Report',
    downloadPDF:'Download PDF',
    print:"Print",
    back: 'Back',
    farmDetails:'Farm Details',

    dimitraFarmId:'Dimitra Farm Id',
    dimitraFermerId:'Dimitra Farmer Id',

    totalGeofenceAreaHA:'Total Geofence Area (HA)',
    forestLossHA:'Forest Loss (HA)',
    forestGainHA:'Forest Gain (HA)',
    forestUnchangedHA:'Forest Unchanged (HA)',
    forestUnchanged:'Forest Unchanged',
    forestLoss:'Forest Loss',
    forestGain:'Forest Gain',
    totalGeofenceArea:'Total Geofence Area',
    forestAssessmentHelp:'If you have questions about this report or need help understanding it, contact us through the Help Desk.',
    allReport:"All Reports",
    deforestationRepot:"Deforestation Reports",
    requestDeforestationReportNow:"REQUEST DEFORESTATION REPORT NOW",
    noRecordFound:"No Record Found",
    noDeforestationReportRequested:"No deforestation reports have been requested. Kindly request some deforestation reports to get them listed here.",
    deforestationImage:"Deforestation Image",
    reqDeforestationReport:"Request Deforestation Report",
    confirm:"Confirm",
    newForestArea:"New Forest Area",
    deforestedArea:"Deforested Area",
    existingForestArea:"Existing Forest Area",
    deforestation:"Deforestation",
    farmName:"Farm Name",
    location:"Location",
    dateOfInterest:"Date of Interest",
    geofenceArea:"GeofenceArea (HA)",
    deforestationArea:"Deforestation Area (HA)",
    treeGainArea:"Tree Gain Area (HA)",
    currentForestArea:"Current Forest Area (HA)",
    view:"View",
    locationInfoRequired:"Location Info is Required",
    geofenceNameRequired:"Geofence name is Required",
    futureDateSelected:"Future date selected",
    reportGeneratedSuccessfully:"Report generated successfully",
    reportCannotAdded:"Report cannot be added.",
    primaryFarmNotFound:"Primary farm not found.",
    pleaseRegisterFarmFirst:"Please register farm first",
  },
  certificate:{
    allCertificate:"All Certificates",
    certificate:"Certificate"
  }
}